import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

graphql(`
  fragment WorkOrderAssignmentFields on WorkOrderAssignment {
    id
    status
    work_order_id
    pro_driver_id
    pickup_date
    pickup_time
    delivery_date
    delivery_time
    driver_pick_up_at
    driver_delivered_at
    booking_reference
    driver_notes
    files {
      ...MediaFields
    }
  }
`);

export const workOrderAssignmentRecordQuery = graphql(`
  query WorkOrderAssignmentRecord($id: ID!) {
    workOrderAssignment(id: $id) {
      id
      status
      work_order_id
      pro_driver_id
      pickup_date
      pickup_time
      delivery_date
      delivery_time
      driver_pick_up_at
      driver_delivered_at
      booking_reference
      driver_notes
      departureImages {
        ...MediaFields
      }
      deliveryImages {
        ...MediaFields
      }
      files {
        ...MediaFields
      }
      workOrder {
        id
        reference
        currency
        departureAddress {
          id
          lat
          lng
          formatted_address_line_1
          formatted_address_line_2
          city
        }
        deliveryAddress {
          id
          lat
          lng
          formatted_address_line_1
          formatted_address_line_2
          city
        }
      }
      proDriver {
        id
        name
        email
        phone
        date_of_birth
        bio
        license_type
        license_number
        license_issuer
        tax_registration
        business_registration_number
        bank_name
        bank_account_name
        bank_account_number
        bank_identifier_code
        has_tow_vehicle
        tow_vehicle_type
        tow_vehicle_year
        tow_capacity_kg
        basedIn {
          id
          name
        }
      }
      payouts {
        id
        status
        amount
        currency
        converted_amount
        converted_currency
        exchange_rate
        transaction_reference
        paid_at
        invoice_url
      }
      expenses {
        id
        type
        paid_by
        paid_to
        amount
        currency
        description
        payout_amount
        created_at

        receipts {
          id
          type
          date
          amount_inc_tax
          amount_tax
          claimable_amount_inc_tax
          currency
          claimable_converted_amount_inc_tax
          converted_currency
          exchange_rate
          description
          image {
            ...MediaFields
          }
        }
      }
    }
  }
`);

export type WorkOrderAssignmentExpense = NonNullable<
  ResultOf<typeof workOrderAssignmentRecordQuery>["workOrderAssignment"]
>["expenses"][number];

export type WorkOrderAssignmentListItem = ResultOf<
  typeof workOrderAssignmentListQuery
>["workOrderAssignments"]["data"][number];

export const workOrderAssignmentListQuery = graphql(`
  query WorkOrderAssignmentList(
    $page: Int!
    $first: Int!
    $search: String
    $supplier_id: ID
    $pro_driver_id: ID
    $status: [WorkOrderAssignmentStatus!]
    $where: QueryWorkOrderAssignmentsWhereWhereConditions
    $orderBy: [QueryWorkOrderAssignmentsOrderByRelationOrderByClause!]
  ) {
    workOrderAssignments(
      page: $page
      first: $first
      search: $search
      supplier_id: $supplier_id
      pro_driver_id: $pro_driver_id
      status: $status
      where: $where
      orderBy: $orderBy
    ) {
      data {
        ...WorkOrderAssignmentFields
        review {
          id
        }
        proDriver {
          id
          name
          email
          phone
          rating
        }
        workOrder {
          id
          reference
          status
          vehicle_type
          supplier {
            id
            name
          }
          departureAddress {
            city
          }
          deliveryAddress {
            city
          }
        }
      }
      paginatorInfo {
        ...PaginationFields
      }
    }
  }
`);
